import intensity1 from './map-icons/minimum-intensity.svg?url'
import intensity2 from './map-icons/medium-intensity.svg?url'
import intensity3 from './map-icons/max-intensity.svg?url'

// deprecated markerer-plus package not handling single quotes correctly
const sanitizeMarkererPlusQuote = (input) => input.replace(/'/g, `"`)

export default [
  {
    url: sanitizeMarkererPlusQuote(intensity1),
    height: 46,
    width: 46,
    textColor: 'white',
  },
  {
    url: sanitizeMarkererPlusQuote(intensity2),
    height: 66,
    width: 66,
    textColor: 'white',
  },
  {
    url: sanitizeMarkererPlusQuote(intensity3),
    height: 90,
    width: 90,
    textColor: 'white',
  },
]
